export default {
  'Haines Junction': { lat: 60.7545, lon: -137.5108 },
  'Watson Lake': { lat: 60.0633, lon: -128.71 },
  Whitehorse: { lat: 60.7212, lon: -135.0568 },
  'Dawson City': { lat: 64.0601, lon: -139.432 },
};
